import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showConfirmation } from '../../../ConfirmationModal';
import TagsBySelection from '../../TagsAndChips/TagsBySelection';
import { showNotification } from '../../../StatusNotification';

export class DocumentTableForm extends Component {
    static displayName = DocumentTableForm.name;

    constructor(props) {
        super(props);
        this.state = {
            documentTable: null,
            documentConfiguration: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            limitEntries: false,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false,
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newDocumentTable = this.state.documentTable;

        if (e.target.name == "isCompact") {
            newDocumentTable[e.target.name] = e.target.checked ? true : false;
        }
        else if (e.target.name == "maxEntries") {
            newDocumentTable[e.target.name] = parseInt(e.target.value);
        }
        else {
            newDocumentTable[e.target.name] = e.target.value;
        }

        this.setState({ documentTable: newDocumentTable });
    }

    handleLimitEntriesChange = (e) => {
        let limitEntries = e.target.checked ? true : false;
        if (limitEntries) {
            this.setState({
                limitEntries: limitEntries
            });
        }
        else {
            let newDocumentTable = this.state.documentTable;
            newDocumentTable['maxEntries'] = 0;

            this.setState({
                limitEntries: limitEntries,
                documentTable: newDocumentTable
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let documentTable = this.state.documentTable;
        documentTable.versionId = this.state.versionId;
        documentTable.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateDocumentTable" : "CreateDocumentTable";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(documentTable),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "DocumentTable", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }
                    
                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName = null;
        let typesField = null;
        let isCompact = false;
        let maxEntries = 0;

        let defaultTypeOpts = [];
        let defaultTypeDDL = <></>;

        let limitEntries = this.state.limitEntries;

        if (this.state.documentTable != null && this.state.documentConfiguration != null) {
            let documentTable = this.state.documentTable;
            let documentConfiguration = this.state.documentConfiguration;

            componentName = documentTable.componentName;
            isCompact = documentTable.isCompact;
            maxEntries = documentTable.maxEntries;

            let types = documentTable.types != "" && documentTable.types != null ? documentTable.types.split(',') : [];
            let typeSelections = documentConfiguration.types != "" && documentConfiguration.types != null ? documentConfiguration.types.split(',') : [];

            let typesKeyVal = [];
            for (var i = 0; i < types.length; i++) {
                typesKeyVal.push({ key: types[i], value: types[i] });
            }
            let typeSelectionsKeyVal = [];
            for (var i = 0; i < typeSelections.length; i++) {
                typeSelectionsKeyVal.push({ key: typeSelections[i], value: typeSelections[i] });
            }

            let allowDelete = this.state.versionStatus == 'draft' ? true : false;
            typesField = <TagsBySelection
                tags={typesKeyVal}
                tagSelections={typeSelectionsKeyVal}
                name='types'
                isRequired={true}
                allowDuplicates={false}
                allowDelete={allowDelete}
                showInput={true}
                tagUpdate={this.handleChange}
            />;

            defaultTypeOpts = types;

            let defaultTypeDDLOpts = [];
            for (var i = 0; i < defaultTypeOpts.length; i++) {
                defaultTypeDDLOpts.push(<option value={defaultTypeOpts[i]}>{defaultTypeOpts[i]}</option>);
            }
            defaultTypeDDL = <select name="defaultType" defaultValue={this.state.documentTable.defaultType} onChange={this.handleChange} >
                <option value=""></option>
                {defaultTypeDDLOpts}
            </select>;
        }

        let maxEntriesField;
        if (this.state.limitEntries) {
            maxEntriesField = <>
                <label htmlFor='docTable-maxEntries'>Max Entries: </label>
                <input id='docTable-maxEntries' name='maxEntries' type='number' defaultValue={maxEntries} onChange={this.handleChange} min={1} step={1} />
            </>;
        }

        

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('DocumentTable')}</h2>
                    </div>

                    <label htmlFor='docTable-componentName'>Component Name:</label>
                    <input id='docTable-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />

                    <label>Type: </label>
                    {typesField}

                    <label>Default Type:</label>
                    {defaultTypeDDL}

                    <label>Compact View: </label>
                    <div className='checkbox-wrapper'>
                        <input name='isCompact' type='checkbox' checked={isCompact} onChange={this.handleChange} />
                    </div>

                    <label>Limit Entries: </label>
                    <div className='checkbox-wrapper'>
                        <input name='limitEntries' type='checkbox' checked={limitEntries} onChange={this.handleLimitEntriesChange} />
                    </div>

                    {maxEntriesField}

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetDocumentTable?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        let limitEntries = data.documentTable.maxEntries > 0 ? true : false;

        this.setState({
            documentTable: data.documentTable,
            documentConfiguration: data.documentConfiguration,
            formType: formType,
            limitEntries: limitEntries
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteDocumentTable?componentId=' + this.state.documentTable.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default DocumentTableForm;
